import "../App.css";
import Header from "../screens/Header";
import TermsAndConditionsScreen from "../screens/TermsAndConditionsScreen";
import Footer from "../screens/Footer";
import ScrollUpBtn from "../components/ScrollUpBtn";

function TermsAndConditions() {
  return (
    <div className="App">
      <Header />
      <TermsAndConditionsScreen />
      <Footer />
      <ScrollUpBtn />
    </div>
  );
}

export default TermsAndConditions;
